<template>
    <div class="c-button-group">
        <button class="c-button" @mousedown="onHold" @touchstart="onHold" @mouseup="offHold" @touchend="offHold">{{text}}</button>
        <div class="c-button-loader" :class="{'fade-out': fadeOut}">
            <svg id="svg" width="122" height="122" viewPort="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" :style="getLoaderScale">
            <circle r="50" cx="61" cy="62" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
            <circle id="bar" r="50" cx="61" cy="62" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="565.48" :style="getLoaderPercent"></circle>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HoldButton', 

        props: [
            'text'
        ],

        data: () => ({
            v: 0,
            a: 0,
            isEnabled: false,
            isHolding: false,
            passedMax: false,
            fadeOut: false,
            is_touch_device: false
        }),

        computed: {
           getLoaderScale: function () {
                return `transform:scale(${1.2 + (0.08 * this.v)})`;
            },

            getLoaderPercent: function () {
                var r = 90;
                var c = Math.PI*(r*2);
                var val = this.v;
            
                if (this.v < 0) { val = 0;}
                if (this.v > 100) { val = 100;}
                
                var pct = ((100-val)/100)*c;

                return `strokeDashoffset: ${pct}`;
            },
        },
        methods:{
            onHold: function (e) {
                e.preventDefault();
                this.isHolding = true;
            },
            offHold: function () {
                this.isHolding = false;
            },
            render: function () {
                // calculate acceleration.
                if (this.isHolding === true) {
                    this.a = this.a * 1.02 + 0.057;
                } else {
                    if (this.v > 0) this.a -= 1;
                }
                // add acceleration to velocity.
                this.v += this.a;


                if(this.v >= 75){
                    this.fadeOut = true;
                }else{
                    this.fadeOut = false;
                }

                if(this.v >= 100 && this.a > 0 && !this.passedMax){
                    this.passedMax = true;
                    this.$emit('max_hit');
                    this.isHolding = false;
                }

                if(this.v < 100 && this.a < 0){
                    this.passedMax = false;
                }

                if (this.isHolding === false) {
                    // bounce.
                    if (this.v < 0) {
                    this.v *= -1;
                    this.a *= -0.2;
                    }
                    // ceil.
                    if (this.v < 2 && Math.abs(this.a) < 1) {
                    this.v = 0;
                    this.a = 0;
                    }
                }
            },
            renderLoop: function () {
                this.render();
                if (this.isEnabled === true) {
                    requestAnimationFrame(() => {
                    this.renderLoop();
                    });
                }
            }
        },

        mounted(){
            this.isEnabled = true;
            this.renderLoop();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/imports";

   .c-button-group{
        position: relative;
        display: inline-block;
    }
    .c-button{
        -webkit-appearance: none;
        border: none;
        background: none;
        margin: 0;
        padding: 0;
        border-radius: 0px;
        margin: 0;
        padding: 0;
        border: none;
        border-radius: 0;
        background: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        -ms-appearance: none;
        -o-appearance: none;
        display: block;
        width:122px;
        height:122px;
        line-height: 122px;
        text-align: center;
        border-radius: 50%;
        color: $gold;
        position: relative;
        font-size: 0.875rem;
        letter-spacing: 0.07rem;
        cursor: pointer;
        transition:0.3s;
        &::after{
            position: absolute;
            top:50%;
            left:50%;
            transform:translate(-50%,-50%);
            width:100%;
            height:100%;
            border:solid 1px $gray-border;
            border-radius:50%;
            content:'';
            opacity: 1;
            transition:0.3s;
            z-index: 1;
        }
        &:hover{
            &::after{
                opacity: 1;
                border:solid 3px $gold;
            }
        }
        &:focus{
            outline:none;
            text-shadow:none;
        }
    }
    .c-button-loader{
        pointer-events: none;
        position: absolute;
        top: 52%;
        left: 50%;
        transform:translate(-50%,-50%);
        transition:opacity 0.5s;
        &.fade-out{
            opacity: 0;
        }
    }

    #svg circle {
    stroke-dashoffset: 0;
    stroke: #fff;
    stroke-width: 1px;
    }
    #svg #bar {
    stroke: $gold;
    }

</style>